import {
  DefaultButton,
  Panel,
  PanelType,
  Stack,
} from "@fluentui/react";
import React from "react";
import { IpanelGeneric } from "../../interfaces/base/IPanel";
import { ButtonForm } from "./buttonForm";
import HeaderGeneric from "./headerPanel";
import { useBoolean } from "@fluentui/react-hooks";


export const PanelGenerico = (props: IpanelGeneric) => {
  const onRenderHeader = React.useCallback(
    () =>
      props.isOnRenderHeader ? (
        <HeaderGeneric
          iconHeader={props.disabledIconHeader}
          iconName={props.iconHeaderName}
          title={props.title}
          subTitle={props.subTitle}
          subTitle2={props.subTitle2}
        ></HeaderGeneric>
      ) : (
        <></>
      ),
    [props.isOpen]
  );

  const onRendeFooter = React.useCallback(
    () =>
      !props.disabledFooter ? (
        <div style={{ padding: "1em" }}>
          <Stack horizontal tokens={{ childrenGap: 10 }} horizontalAlign="space-between">
            <Stack horizontal tokens={{ childrenGap: 8 }}>
              {props.showExportButton && (
                <DefaultButton
                  iconProps={{ iconName: "ExcelDocument" }}
                  text="Exportar"
                  onClick={props.exportarExcel}
                />
              )}
            </Stack>
            
            <Stack horizontal tokens={{ childrenGap: 8 }}>
              <DefaultButton onClick={props.cancelar}>Cancelar</DefaultButton>
              {props.registrar && (
                <DefaultButton 
                  primary 
                  onClick={() => props.registrar && props.registrar()}
                  disabled={props.disabledRegister}
                >
                  {props.textRegister || "Guardar"}
                </DefaultButton>
              )}
            </Stack>
          </Stack>
        </div>
      ) : (
        <></>
      ),
    [props]
  );
  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={props.onDismiss}
      type={PanelType.medium}
      closeButtonAriaLabel="Close"
      isLightDismiss={true}
      onRenderHeader={onRenderHeader}
      onRenderFooter={props.disabledFooter? props.onRendeFooter : onRendeFooter}
      onRenderBody={props.onRenderBody}
      isFooterAtBottom={true}
    >
      {props.children}
    </Panel>
  );
};